import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LanguageState, Language, LayoutType } from './types';
import { LAYOUT_LANGUAGES, LANGUAGE_KEY, LANGUAGES, LAYOUT_TYPES, defaultLanguageForLayout } from './constants';
import { isLanguageAvailable } from '../lib/utils';

const getSavedLanguage = (): Language['code'] => {
  const saved = localStorage.getItem(LANGUAGE_KEY);
  if (saved) return saved;

  const browserLang = navigator.language || navigator.languages?.[0] || LANGUAGES.en.code;
  const langCode = browserLang.split('-')[0].toLowerCase();

  const supportedLanguage = Object.values(LANGUAGES).find((lang) => lang.code === langCode);
  return supportedLanguage?.code ?? LANGUAGES.en.code;
};

const initialState: LanguageState = {
  currentLanguage: getSavedLanguage(),
  layoutType: LAYOUT_TYPES.PUBLIC,
  availableLanguages: [...LAYOUT_LANGUAGES.public]
};

export const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    setLanguage: (state, action: PayloadAction<Language['code']>) => {
      if (isLanguageAvailable(action.payload, state.layoutType)) {
        state.currentLanguage = action.payload;
        localStorage.setItem(LANGUAGE_KEY, action.payload);
      }
    },
    setLayoutType: (state, action: PayloadAction<LayoutType>) => {
      state.layoutType = action.payload;
      state.availableLanguages = [...LAYOUT_LANGUAGES[action.payload]];

      if (!isLanguageAvailable(state.currentLanguage, action.payload)) {
        state.currentLanguage = defaultLanguageForLayout[action.payload];
        localStorage.setItem(LANGUAGE_KEY, state.currentLanguage);
      }
    }
  }
});

export const { setLanguage, setLayoutType } = languageSlice.actions;
